<template>
  <v-card
    :style="styles"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <helper-offset
      v-if="hasOffset"
      :inline="inline"
      :full-width="fullWidth"
      :offset="offset"
    >
      <v-card
        v-if="!$slots.offset"
        :color="color"
        :elevation="elevation"
        class="v-card--material__header align-center"
        dark
      >
        <slot
          v-if="!title && !text"
          name="header"
        />
        <v-card-title
          v-if="title && !text"
          class="justify-center pa-6 font-calibri"
        >
          {{ title }}
        </v-card-title>

        <div
          v-if="title && text"
          class="pa-5 pl-8"
        >
          <h4
            class="title font-weight-light font-weight-bold font-size-18"
            style="margin-bottom:-3px !important;font-family:calibri !important"
            v-text="title"
          />
          <p
            class="category font-weight-thin mb-0 font-italic font-size-16 font-calibri"
            v-text="text"
          />
        </div>
      </v-card>

      <slot
        v-else
        name="offset"
      />
    </helper-offset>

    <slot
      v-if="loading"
      name="progress"
    >
      <v-container
        style="height: 150px;"
      >
        <v-row
          class="fill-height"
          align="center" 
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </v-row>     
      </v-container>
    </slot>

    <v-card-text>
      <slot />
    </v-card-text>

    <v-divider
      v-if="$slots.actions"
      class="mx-4"
    />

    <v-card-actions v-if="$slots.actions">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'MaterialCard',
    components: {
      HelperOffset: () => import('@/components/helper/Offset'),
    },
    
    inheritAttrs: false,
    props: {
      color: {
        type: String,
        default: 'secondary',
      },
      elevation: {
        type: [Number, String],
        default: 10,
      },
      inline: {
        type: Boolean,
        default: false,
      },
      fullWidth: {
        type: Boolean,
        default: false,
      },
      offset: {
        type: [Number, String],
        default: 24,
      },
      title: {
        type: String,
        default: undefined,
      },
      text: {
        type: String,
        default: undefined,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      hasOffset () {
        return this.$slots.header ||
          this.$slots.offset ||
          this.title ||
          this.text
      },
      styles () {
        if (!this.hasOffset) return null

        return {
          marginBottom: `${this.offset}px`,
          marginTop: `${this.offset * 2}px`,
        }
      },
    },
  }
</script>

<style scoped>
.font-size-18{
  font-size: 18px;
}

.font-size-16{
  font-size: 16px;
}
.font-calibri{
  font-family: 'Calibri' !important;
}
</style>
